import {makeStyles} from "@material-ui/core/styles";

export const centerStyle = makeStyles((theme) => ({
    alignItemsAndJustifyContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));